import "@mantine/core/styles.css";
import "@mantine/carousel/styles.css";
import "@assets/styles/fonts.css";
import "@assets/styles/wordpress-theme.css";
import "@assets/styles/util.css";

import React from "react";
import { MantineProvider } from "@mantine/core";
import { theme, resolver } from "@assets/theme";

export const wrapPageElement = ({ element }) => {
  return (
    <MantineProvider
      theme={theme}
      cssVariablesResolver={resolver}
      classNamesPrefix="bigmode"
      withGlobalStyles
      withNormalizeCSS
    >
      {element}
    </MantineProvider>
  );
};
